var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1a2a1c198f5c6a549da4f7a111c88cb6a4486633"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lifeworkcalendar@reclaimai"]={id:"1a2a1c198f5c6a549da4f7a111c88cb6a4486633"};
      